import gql from 'graphql-tag';

const CREATE_INVITATION = gql`
  mutation createInvitation($email: String) {
    createInvitation(email: $email) {
        message
    }
  }
`;

const UPDATE_INVITATION = gql`
  mutation updateInvitation($token: String!, $status: String!) {
    updateInvitation(token: $token, status: $status) {
        message
    }
  }
`;

export {
  CREATE_INVITATION, UPDATE_INVITATION,
};
